<div class="dialog-header">
  <button mat-button class="close-button-container" disableRipple="true" (click)="closeDialog()">
    <mat-icon>arrow_back</mat-icon>
  </button>

  <div class="header-title">
    <span style="font-size: 120%;">Comments</span>
  </div>
</div>

<div class="comments-block">
  <div class="spinner-box" *ngIf="commentsLoading">
    <lib-progress-spinner></lib-progress-spinner>
  </div>
  <div [id]="'commentsList'" class="comments-list" *ngIf="!commentsLoading">
    <div class="comments-row" *ngFor="let taskComment of taskComments; trackBy: trackEntityById"
         [id]="taskComment.id">

      <div class="comment-block">

        <div class="parent-comm">
          <div class="comment-user">
            <div class="avatar-block">
              <div class="word-avatar" style.background-color="#{{taskComment.user.bgColor}}">
                <div class="short-name">
                  {{taskComment.user.shortCode}}
                </div>
              </div>
            </div>
            <span class="user-name">{{taskComment.user.name}} </span>
            <span class="time">{{taskComment.createdTime | date: 'MMM dd'}} at
              {{taskComment.createdTime | date: 'H:mm aaa'}} </span>
          </div>

          <div class="comment-title-block">
            <div class="comment-title" appUserMentionContent [content]="taskComment.text"
                 [mentions]="taskComment.mentions">{{taskComment.text}}
            </div>
          </div>
        </div>

      </div>
    </div>

  </div>

  <div class="textarea-block" *ngIf="!commentsLoading">

    <div class="area-block">
      <input #punchItemTextArea class="text-area-task-comment" matInput placeholder="Write a comment..." [required]="true"
             minlength="3" type="text" [(ngModel)]="itemDescription" name="itemDescription" [mention]="users"
             [mentionConfig]="{triggerChar:'@', maxItems:25, labelKey:'username', mentionSelect: onMentionSelect}">
    </div>
    <div class="buttons-block">
      <button mat-button class="add-item-button" (click)="addComment()"
              [ngClass]="{'disabled-button': loadingSpinner}" [disabled]="loadingSpinner">
        <span *ngIf="!loadingSpinner">Add</span>
        <lib-mini-progress-spinner *ngIf="loadingSpinner"></lib-mini-progress-spinner>
      </button>
    </div>
  </div>
</div>
